import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { InputBase } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import AppBarMainMenu from "./AppBarMainMenu";
import I18N from "../utils/I18N";
import { alpha } from "@mui/material/styles";
import { styled } from "@mui/material";

const SearchWrapper = styled("div")(({ theme }) => {
  return {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },
  }
});
const SearchIconWrapper = styled("div")(({ theme }) => {
  return {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  }
});

const AppTitle = styled((props) => {
  return <Typography variant="h6" noWrap {...props} sx={{ display: { sm: "block" } }} />
})({
  flexGrow: 1,
  display: "none"
});

export default function SearchAppBar() {
  return (
    <div style={{ flexGrow: 0 }}>
      <AppBar position="static">
        <Toolbar>
          <AppBarMainMenu />
          <AppTitle>
            {I18N.labels.appTitle}
          </AppTitle>
          <SearchWrapper>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <InputBase
              placeholder={`${I18N.labels.search}...`}
              sx={{
                "&.MuiInputBase-root": { color: "inherit" },
                "&.MuiInputBase-input": ({ theme }) => {
                  return {
                    padding: theme.spacing(1, 1, 1, 0),
                    // vertical padding + font size from searchIcon
                    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
                    transition: theme.transitions.create("width"),
                    width: "100%",
                    [theme.breakpoints.up("sm")]: {
                      width: "12ch",
                      "&:focus": {
                        width: "20ch",
                      },
                    },
                  }
                }
              }}
              inputProps={{ "aria-label": "search" }}
            />
          </SearchWrapper>
        </Toolbar>
      </AppBar>
    </div>
  );
}
